var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "honour-card"
  }, [_c("img", {
    attrs: {
      src: require(`@/assets/images/aboutUS/${_vm.img}`),
      alt: ""
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };